import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button } from "nq-component";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import OBForApprovalPresenter from "./OBForApprovalPresenter";
import InputFactory from "../../../components/InputFactory";
import DateRangePicker from "../../../components/common/DateRangePicker";

class OBForApprovalPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
      where: {},
      whereReady: false,
    };
    this.presenter = new OBForApprovalPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "ob_requests";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  setWhere(where) {
    this.setState({ where, whereReady: true });
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  handleViewData(object){
    this.navigateTo(`/form/${this.getCollectionName()}/${object.id}`, {isViewMode: true});
  }

  handleApprove(data){
    this.presenter.handleStatusChange(data, "Forwarded to CEBS");
  }

  handleDisapprove(data){
    this.presenter.handleStatusChange(data, "Disapproved");
  }

  render() {
    const { objects, loading, count, limit, current, where, whereReady } =
      this.state;

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
        fields !== "employee" &&
        fields !== "createdAt" &&
        fields !== "status"
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Human Resource {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    OB For Approval
                  </span>
                </p>
              </div>
              {/* <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView> */}

             <CardView style={{ borderRadius: 0}}>
                <div className="row align-items-center">
                  <div className="col-md-4 d-flex align-items-center">
                    <DateRangePicker
                      width="100%"
                      fields={["createdAt", "updatedAt", ""]}
                      onFilter={(filterObj) => {
                        try {
                          const update = new Date(filterObj.updatedAt.$lte);
                          update.setDate(update.getDate() + 1);
                          const formattedDate = update
                            .toISOString()
                            .split("T")[0];
                          const filterStartDate = {
                            createdAt: {
                              $lte: formattedDate,
                              $gte: filterObj.createdAt.$gte,
                            },
                          };
                          this.searchSubmit(filterStartDate);
                          this.setState({ filters: filterStartDate });
                        } catch (e) {
                          this.searchSubmit({});
                          this.setState({ filters: {} });
                        }
                      }}
                    />
                  </div>
                  {Object.keys(schema.filters || {}).map((field) => {
                    let { type, where: filterWhere, ...options } =
                      schema.filters[field];
                    if (field === "employee") {
                      if (!whereReady) {
                        return (
                          <div
                            key={field}
                            className="col-md-4 d-flex align-items-center text-muted fs-sm"
                          >
                            Loading employees...
                          </div>
                        );
                      }
                      filterWhere = where || {};
                    }
                    return (
                      <div
                        key={
                          field === "employee"
                            ? `${field}-${JSON.stringify(filterWhere)}`
                            : field
                        }
                        className="col-md-4 d-flex align-items-center"
                      >
                        <div style={{ width: "100%" }}>
                          <InputFactory
                            className="ms-1"
                            type={type}
                            field={field}
                            where={filterWhere}
                            onChange={this.onChangeFilter.bind(this, type)}
                            {...options}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </CardView>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center  justify-content-center">
                    <h4 className="text-primary">OB For Approval</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                viewPayroll={this.handleViewData.bind(this)}
                stepIncrement={this.handleApprove.bind(this)}
                separateEmployee={this.handleDisapprove.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "OB Approval List",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(OBForApprovalPage);
